<template>
  <!-- 支持拼音搜索所用的下拉框 -->
  <div class="public-combobox-container">
    <el-select ref="select" v-if="optionsList" :value="value" @change="valueChange" :clearable="clearable" :filterable="filterable" :filter-method="filterMethods" @visible-change="visableChange" :placeholder="placeholder" :collapse-tags="collapseTags" :multiple="multiple">
      <el-option v-for="o in defaultOptions" :key="o.id" :label="o.name" :value="o.id"/>
      <template v-for="option in dataListSource">
        <el-option v-for="item in option.columns" :key="item.id" :label="computedByLabel ? getComputed(item, option) : item.name" :value="item.id" :disabled="item.disabled"/>
      </template>
    </el-select>
    <el-select ref="select" v-else :value="value" @change="valueChange" :clearable="clearable" :filterable="filterable" :filter-method="filterMethods" @visible-change="visableChange" :placeholder="placeholder" :collapse-tags="collapseTags" :multiple="multiple">
      <el-option v-if="isShowOptions(item)" v-for="item in dataSource" :key="item.id" :label="getComputed(item, {})" :value="item.id" :disabled="item.disabled"/>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'public-combobox',
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      default: () => { return [] }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    computedByLabel: {
      type: Object,
      default: null
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    optionsList: {
      type: Array,
      default: null
    },
    defaultOptions: {
      type: Array,
      default: null
    },
    optionsVisable: {
      type: Object,
      default: null
    },
    // 默认显示的条数
    showOperationLength: {
      type: Number,
      default: -1
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      dataSource: [],
      dataListSource: [],
      isFirst: true
    }
  },
  methods: {
    valueChange (value) {
      this.$emit('change', value)
    },
    filterMethods (val) {
      if (val) {
        if (this.optionsList) {
          let list = []
          this.optionsList.forEach(item => {
            if (item.name.includes(val) || (item.pinyinName && item.pinyinName.includes(val)) || (item.pinyinFirstChar && item.pinyinFirstChar.includes(val))) {
              list.push({...item})
            } else {
              if (item && item.columns && item.columns.length) {
                let columns = item.columns.filter(t => t.name.includes(val) || (t.pinyinName && t.pinyinName.includes(val)) || (t.pinyinFirstChar && t.pinyinFirstChar.includes(val)))
                columns && list.push({
                  columns,
                  id: item.id,
                  name: item.name,
                  tableId: item.tableId,
                  isNew: item.isNew
                })
              }
            }
          })
          this.$set(this, 'dataListSource', [...list])
        } else {
          let arr = []
          if (this.computedByLabel && this.computedByLabel.methods === 'component-interaction' && this.computedByLabel.isProcess) {
            arr = this.options.filter(t => t.name.includes(val) || (t.pnl && t.pnl.includes(val)) || (t.pfcl && t.pfcl.includes(val)))
          } else {
            arr = this.options.filter(t => t.name.includes(val) || (t.pinyinName && t.pinyinName.includes(val)) || (t.pinyinFirstChar && t.pinyinFirstChar.includes(val)))
          }
          if (this.showOperationLength !== -1) {
            arr = arr.splice(0, this.showOperationLength)
          }
          this.$set(this, 'dataSource', this.disposeOptions(arr))
        }
      } else {
        if (this.optionsList) {
          this.$set(this, 'dataListSource', this.optionsList)
        } else {
          let list = this.$_.merge([], this.options)
          if (this.showOperationLength !== -1) {
            list = list.splice(0, this.showOperationLength)
          }
          this.$set(this, 'dataSource', this.disposeOptions(list))
        }
      }
    },
    visableChange (e) {
      if (!e) {
        this.filterMethods(null)
      }
    },
    disposeOptions (source) {
      let options = this.$_.merge([], source)
      if (this.disabled) {
        if (this.disabled.key === 'setting-value') {
          options.forEach(o => (o.disabled === o.isNew))
        } else if (this.disabled.key === 'component-interaction') {
          options.forEach(o => {
            o.disabled = this.getDisabled(this.disabled.interaction, this.disabled.item, o, options)
          })
        } else if (this.disabled.key === 'process-dialog-second-field') {
          let interactionFields = this.disabled.interactionFields
          let secondField = this.disabled.secondField
          options.forEach(o => {
            o.disabled = interactionFields.find(n => n.secondField === o.id) && secondField !== o.id
          })
        } else if (this.disabled.key === 'group-panel') {
          options.forEach(o => {
            o.disabled = o.used || this.disabled.group.columnId === o.id
          })
        }
      }
      return options
    },
    getDisabled (interaction, item, option, source) {
      // 显示隐藏不占位只对分组控件
      if (option.componentType === 'rc-group' && ['visibility', 'readonly', 'edit', 'required', 'noRequired', 'calculate', 'clear'].some(n => item.actionType.includes(n))) {
        return true
      }

      // 一旦选择了表格内的控件那无法选择执行控件
      for (let i = 0; i < interaction.triggerComponents.length; i++) {
        if (interaction.triggerComponents[i].triggerComponent === option.id) {
          return true
        }
        let triggerComponent = source.find(option => option.id === interaction.triggerComponents[i].triggerComponent)
        if (triggerComponent && triggerComponent.tableId && triggerComponent.tableId !== option.tableId) {
          return true
        }
      }
      return false
    },
    // 为了处理超链接属性面板中的下拉框切换
    setOptions (val) {
      let item = this.options.find(o => o.id === val)
      if (item && !this.dataSource.find(c => c.id === item.id)) {
        this.dataSource.pop()
        this.dataSource.push({...item})
      }
    }
  },
  computed: {
    getComputed (item, options = {}) {
      if (this.computedByLabel !== null) {
        if (this.computedByLabel.methods.includes('component-interaction')) {
          return (item, options) => {
            let label = item.name
            if (item.tableName) {
              label = `${item.tableName}-${label}`
            }
            if (this.computedByLabel.isProcess) {
              label = `${item.formName}-${label}`
            }
            return label
          }
        } else if (this.computedByLabel.methods === 'process-dialog-compareField') {
          return (item, options) => `${options.name}-${item.name}`
        } else {
          return (item, options) => item.name
        }
      } else {
        return (item, options) => item.name
      }
    },
    isShowOptions (item) {
      return item => {
        if (this.optionsVisable) {
          if (this.optionsVisable.key === 'order-panel') {
            return !item.used || this.optionsVisable.order.columnId === item.id
          }
        } else {
          return true
        }
      }
    }
  },
  watch: {
    options: {
      handler (val) {
        this.filterMethods(null)
      },
      deep: true
    },
    optionsList: {
      handler (val) {
        this.filterMethods(null)
      },
      deep: true
    }
  },
  created () {
    this.filterMethods(null)
    if (this.value) {
      let unWatch = this.$watch(() => this.options.length, val => {
        if (val > 0 && this.isFirst && this.showOperationLength !== -1) {
          let item = this.options.find(o => o.id === this.value)
          if (item && !this.dataSource.find(c => c.id === item.id)) {
            this.dataSource.pop()
            this.dataSource.push({...item})
          }
          unWatch()
        }
      })
    } else {
      let unWatch = this.$watch(() => this.value, val => {
        if (val && this.isFirst && this.showOperationLength !== -1) {
          let item = this.options.find(o => o.id === val)
          if (item && !this.dataSource.find(c => c.id === item.id)) {
            this.dataSource.pop()
            this.dataSource.push({...item})
          }
          unWatch()
        }
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/public/public-combobox.vue